module.exports = __webpack_public_path__ + "static/logo-e9353e12932a529c98da6f6d45fd35af.svg";